import i18n from '~/locales/i18n';

i18n.addResourceBundle('en', 'app', {
  basicInfo: 'Basic Information',
  listingDescription: 'Listing Description',
  listingDetails: 'Listing Details',
  photosVideos: 'Photos & Videos',
  publish: 'Publish',
  confirmPhoneNumberMessage:
    'Please confirm your phone number to publish your listing',
  mySettings: 'My Settings',
  follow: 'Continue',
  optional: 'Optional',
  referenceNumber: 'Referance Number',
  enterReferenceNumberText: 'Enter the reference number',
  chooseSection: 'Choose The Section',
  propertyType: 'Property Type',
  choosePropertyType: 'Choose The Property Type',
  location: 'Location',
  requiredPropertyType: 'Select property type',
  locationOfPropertyOnMap: 'Location of the property on the map',
  requiredMap: 'Select location on the map',
  noResults: 'No Results',
  missingPropertyLocation: "Can't find your property location?",
  newLocationRequest: 'Request to add a new location',
  regionRestrictionMessage:
    'Your package does not support adding a listing in this area',
  requiredLocation: 'Select location',
  chooseLocation: 'Choose the location',
  arabic: 'Arabic',
  english: 'English',
  listingName: 'Listing Name',
  listingNamePlaceholder:
    'Example: Apartment for sale in Moon Residence - Al Marasem...',
  listingNameLabel:
    'This name appears as the main title on your listing with us.',
  listingDetailsPlaceholder: 'Property Details',
  listingAddress: 'Property Address',
  listingAddressPlaceholder: 'Example: 21 Dr. Naguib Mahfouz, Nasr City …',
  listingTitleError: 'Please enter the listing name',
  listingDescriptionError: 'Please enter the listing description',
  listingAddressError: 'Please enter the property address',
  listingTitleMaxLength:
    'This value is too long. It should be 100 characters or less.',
  listingAddressMaxLength:
    'Property address should be less than 100 characters',
  descriptionAlert1:
    'Describe the property in both Arabic and English to attract more buyers.',
  descriptionAlert2:
    'Add a good title to your adv to encourage buyers to view it.',
  tipsForListing: 'Tips for a better adv',
  detailsOfListing: 'Listing Details',
  addListingPageTitle: 'List property •  | Aqarmap',
  videosAndPhotos: 'Videos and Photos',
  propertyPhotos: 'Property Photos',
  selectAll: 'Select All',
  delete: 'Delete',
  addPhotosHere: 'Add photos here',
  dragPhotosHere: 'Drag photos here',
  maxFileSize: 'Max size: 30 MB',
  videoLink: 'Video Link',
  youtubeLink: 'Add YouTube video link',
  mainPhoto: 'Main Photo',
  mediaAlert1: 'Listings with more than 3 photos get 5 times more engagement',
  mediaAlert2: 'Use real photos of the property',
  publishListing: 'Publish Listing',
  meter: 'm²',
  bathroom: 'Bathroom',
  rooms: 'Rooms',
  publishNow: 'Publish Now',
  payNow: 'Pay Now',
  payAndPublishListing: 'Pay & Publish Your Listing',
  listingCost: 'Listing Cost',
  listingPriceForLocation: 'Listing price for this location',
  area: 'Area',
  byMeter: 'm²',
  areaPlaceholder: 'Enter the area',
  bathesNumber: 'Number of bathrooms',
  bathesNumberPlaceholder: 'Enter the number of bathrooms',
  floor: 'Floor',
  floorPlaceholder: 'Enter the floor',
  roomsNumber: 'Number of rooms',
  roomsNumberPlaceholder: 'Enter the number of rooms',
  propertyTypeMarket: 'Property type in the market',
  view: 'View',
  finishType: 'Finish type',
  listingPrice: 'Property price',
  price: 'Price',
  paymentMethod: 'Payment method',
  egyptianPound: 'EGP',
  pricePerMeterUnit: 'EGP/m²',
  buildYearOrDeliveryYear: 'Year of construction or delivery',
  buildYearOrDeliveryYearPlaceholder: 'Select Delivery Year',
  in: 'in',
  floors: 'Number of floors',
  floorsPlaceholder: 'Enter number of floors',
  apartments: 'Apartments',
  apartmentsPlaceholder: 'Enter number of apartments',
  landArea: 'Land area',
  landAreaPlaceholder: 'Enter land area',
  propertyRegistrationStatus:
    'Property registration status in the notary public',
  propertyIsMortgageApproved:
    'Is your property eligible for mortgage financing?',
  others: 'Others',
  areaRequired: 'Please enter the area',
  priceRequired: 'Please enter the price',
  propertyViewRequired: 'Please select the view',
  propertyTypeMarketRequired: 'Please select the property type in the market',
  bathesNumberError: 'Please enter the number of bathrooms',
  floorError: 'Please enter the floor',
  roomsNumberError: 'Please enter the number of rooms',
  buildYearError: 'Please enter the year of construction or delivery',
  floorsError: 'Please enter the number of floors',
  apartmentsError: 'Please enter the number of apartments',
  landAreaError: 'Please enter the land area',
  propertyTypeError: 'Please select the property type',
  propertyRegistrationStatusError:
    'Please select the property registration status in the notary public',
  buyPackageLabel: 'You do not have enough balance to publish this listing',
  buyPackageDesc:
    'You can purchase one of the packages available to publish your listing.',
  paymentMethodRequired: 'Please select a payment method',
  point: 'Point',
  requiredPhotos: 'Please enter at least {{count}} photos',
  sizeMoreThan2MG: 'File size exceeds 30 MB',
  finishTypeRequired: 'Please select the finish type',
  buyPackage: 'Buy Package',
  errorPhotosSize:
    'The image “{{fileName}}” is larger than {{fileSize}} MB and cannot be uploaded.',
  videoInvalidError:
    'The video link is invalid. It must be a valid YouTube link.',
  autoGenerate: 'Auto Generate',
  autoGenerated: 'Generated Successfully',
  listingAmenities: 'Listing Amenities',
  BALCONY: 'Balcony',
  SECURITY: 'Security',
  ELEVATOR: 'Elevator',
  ELECTRICITY_METER: 'Electricity Meter',
  WATER_METER: 'Water Meter',
  NATURAL_GAS_METER: 'Natural Gas Meter',
  LANDLINE_PHONE: 'Landline Phone',
  PETS_ALLOWED: 'Pets Allowed',
  COVERED_PARKING: 'Covered Parking',
  SWIMMING_POOL: 'Swimming Pool',
  PRIVATE_GARDEN: 'Private Garden',
  MAID_ROOM: "Maid's Room",
  AIR_CONDITIONING: 'Air Conditioning',
  KITCHEN_APPLIANCES: 'Kitchen Appliances',
  KIDS_PLAY_AREA: 'Kids Play Area',
  totalInstallmentPrice: 'Total Installment Price',
  detailsSummaryTitle: 'Details Summary',
  reviewYourDataBeforeContinue: 'Review your details before continuing',
  salePrice: 'Sale Price',
  totalInstallmentPricePlaceholder: 'Enter total installment price',
  totalInstallmentPriceRequired: 'Please enter the total installment price',
  downPaymentPrice: 'Down Payment',
  isThereDownPayment: 'Downpayment?',
  downPaymentPricePlaceholder: 'Enter Down payment',
  downPaymentPercentagePlaceholder: 'Enter down payment',
  downPaymentRequired: 'Please enter the down payment',
  paidAmountRequired: 'Please enter the paid amount',
  installmentPeriod: 'Installment Period',
  inMonths: 'in months',
  months: 'Months',
  installmentPeriodPlaceholder: 'Maximum Installment Period',
  monthlyInstallment: 'Monthly Installment',
  listingPercentage: 'Down payment is',
  fromListingPrice: 'of the property price',
  cashPrice: 'Cash Price',
  cashPricePlaceholder: 'Enter the cash price',
  rentalDuration: 'Rent Duration',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  rentDailyInputPlaceholder: 'Enter daily rent price',
  rentWeeklyInputPlaceholder: 'Enter weekly rent price',
  rentMonthlyInputPlaceholder: 'Enter monthly rent price',
  installmentsYearsRequired: 'Please select a specific installment period',
  remainingInstallmentPeriodRequired:
    'Please enter the remaining installment period',
  dailyPriceRequired: 'Please enter the daily rent price',
  weeklyPriceRequired: 'Please enter the weekly rent price',
  monthlyPriceRequired: 'Please enter the monthly rent price',
  downPaymentPercentageRequired: 'Please enter the down payment percentage',
  abbreviationEgyptianPound: 'EGP',
  day: 'Day',
  month: 'Month',
  week: 'Week',
  year: 'Year',
  years: 'Years',
  downPaymentMustBeLessThanTotalInstallmentPrice:
    'Down payment must be less than total installment price',
  downPaymentMustBeAtLeastOnePercent: 'Minimum downpayment is 1% of the price.',
  totalInstallmentPriceMustBeLargeThanPrice:
    'Total installment price must be larger than property price',
  durationMustBeLessThan30Years: 'Please enter a valid installment duration',
  contractPriceRequired: 'Please enter the contract price',
  contractPrice: 'Contract Price',
  contractPriceTooltip:
    'The unit price agreed upon in the contract with the developer, before adding the over price or any other amounts',
  overPrice: 'Over Price',
  securityDeposit: 'Maintenance Deposit',
  paidAmount: 'Paid amount',
  totalRequiredDownPaymentFromBuyer:
    'Total down payment required from the buyer',
  totalRequiredDownPaymentTooltip:
    'The total amount that must be paid to the current owner upon completing the purchase, including the total amounts previously paid in addition to the over price deposit (if any).',
  totalPaidAmounts: 'Total Amounts Paid',
  totalPaidAmountsTooltip:
    'The total amounts paid to the developer so far, including the reservation down payment and all installments paid, excluding the over price or the maintenance deposit.',
  totalPropertyPrice: 'Total property price',
  remainingAmount: 'Remaining Amount',
  LUX: 'Luxury',
  SUPER_LUX: 'Super Luxury',
  EXTRA_SUPER_LUX: 'Extra Super Luxury',
  SEMI_FINISHED: 'Semi Finished',
  WITHOUT_FINISH: 'Unfinished',
  errorOccurred: 'An error occurred, please try again later',
  remainingInstallmentDuration: 'Remaining Installment Period',
  marketListingTypeTitle: 'Choose listing type',
  marketListingTypeDescription:
    'Is this listing a resale unit or a primary unit inside the compound?',
  resale: 'Resale',
  primary: 'Primary',
  cloneUnitsModalDescription:
    'Use the compound information we have for better and faster experience ',
  clone: 'Clone',
  skip: 'Skip',
  seeMore: 'See more',
  seeLess: 'See less',
  choseUnit: 'Select Unit',
  publishAccountTitle: 'Publish this listing for',
  mainAccount: 'Main Account',
  mainAccountPublishDesc:
    'Credits are deducted from the main account. The listing is published under its name, with you as the publisher.',
  myAccountPublishDesc:
    'Credits are deducted from your balance, and the listing is published under your name.',
  insufficientBalance: "Your balance isn't enough",
  subscribeToPackage: 'Charge your balance',
  publishAccountPayNow: 'Pay Now',
  publishAccountPayNowCredits: 'Pay Now ({{credits}} Credits)',
  mainAccountConfirmCredits: 'credits will be deducted from the main account.',
  mainAccountConfirmDesc:
    "The listing will be published under the main account's name, with you as the publisher.",
  dontShowAgainThisSession: "Don't show this message again this session",
});
